module.exports = __webpack_public_path__ + "static/media/IMG_0719.f4d41ac8.JPG";